import moment from 'moment';
import axios from './financeiroApi';

const gestaoEnvioApi = () => {
  const getPathGestaoEnvio = () => {
    return `/api/v1/backend/gestao-envio`;
  };

  const getParams = (filtro) => {
    let newFiltro = { ...filtro };

    if (filtro?.filtroAvancado) {
      newFiltro = {
        ...newFiltro,
        ...filtro.filtroAvancado,
      };
    }

    if (moment.isMoment(newFiltro?.periodoEnvioInicio)) {
      newFiltro.periodoEnvioInicio = newFiltro.periodoEnvioInicio.format('YYYY-MM-DD - HH:mm');
    }

    if (moment.isMoment(newFiltro?.periodoEnvioFim)) {
      newFiltro.periodoEnvioFim = newFiltro.periodoEnvioFim.format('YYYY-MM-DD - HH:mm');
    }

    return newFiltro;
  };

  return {
    buscarGestaoEnvio: async (filtro) => {
      const url = `${getPathGestaoEnvio()}`;
      return axios.get(url, { params: getParams(filtro) });
    },
    buscarPeloId: async (gestaoEnvioId) => {
      const url = `${getPathGestaoEnvio()}/${gestaoEnvioId}`;
      return axios.get(url);
    },
    buscarSomatorioGestaoEnvio: async (filtro) => {
      const url = `${getPathGestaoEnvio()}/somatorio`;
      return axios.get(url, { params: getParams(filtro) });
    },
  };
};
export { gestaoEnvioApi };
